import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Stack,
  Container,
  Typography,
  Snackbar,
  Alert,
  Box,
  IconButton,
  CircularProgress
} from '@mui/material';
import dayjs from 'dayjs';
import moment from 'moment';
import { getDistance } from 'geolib';
import { LoadingButton } from '@mui/lab';
import { useLocation, useNavigate } from 'react-router-dom';

//components
import { api } from 'src/Api';
import Page from '../../components/Page';
import Iconify from 'src/components/Iconify';
import Scrollbar from 'src/components/Scrollbar';
import BookingRate from 'src/components/MyShipment/BookingRate';
import AudienceForm from 'src/components/MyShipment/AudienceForm';
import ShipmentDetailsForm from 'src/components/MyShipment/ShipmentDetailsForm';

//icons

export default function AddShipment() {
  const location = useLocation();
  const { viewOnly, detail_id, data } = location.state || {};

  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user'));

  const [oneFormOpen, setOneFormOpen] = useState(true);
  const [secondFormOpen, setSecondFormOpen] = useState(true);
  const [bookingFormOpen, setBookingFormOpen] = useState(true);
  const [loading, setloading] = useState(false);

  const [errors, setErrors] = useState({});
  console.log('🚀 ~ AddShipment ~ errors:', errors);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [isSaveLoading, setIsSaveLoading] = useState(null);
  const [convertedLength, setConvertedLength] = useState('');
  const [convertedWeight, setConvertedWeight] = useState('');

  // profile form Data
  const [formData, setFormData] = useState({
    origin: '',
    dho: '',
    destination: '',
    dhd: '',
    dateEarliest: null,
    dateLatest: null,
    timeStart: null, // Time range for MultiInputTimeRangeField
    timeEnd: null, // Time range for MultiInputTimeRangeField
    truckType: 'Full',
    equipmentType: '',
    length: '',
    length_unit: 'ft',
    weight_unit: 'kg',
    weight: '',
    comment: '',
    commodity: '',
    referenceId: '',
    contact: '',
    postOption: '',
    tracking: false,
    private_network: 'Private',
    allow_carriers: false,
    request_type: '',
    FL_DAT_value: '',
    // FL_Private_value: '',
    allow_bids: false,
    auto_bid_cancel: false,
    maximum_rate: '',
    distance: '',
    group_id: ''
  });
  console.log('🚀 ~ AddShipment ~ formData:', formData);

  useEffect(() => {
    if (detail_id) {
      getShipmentList();
    }
  }, []);

  useEffect(() => {
    if (formData?.origin && formData?.destination) {
      if (formData?.origin?.address === formData?.destination?.address) {
        setFormData({
          ...formData,
          destination: null
        });
        setSnackbarMessage('Origin and Destination locations cannot be the same');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      } else {
        if (
          formData?.origin &&
          formData?.origin &&
          formData?.destination &&
          formData?.destination
        ) {
          handleGetKilometers(
            formData?.origin?.lat,
            formData?.origin?.lon,
            formData?.destination?.lat,
            formData?.destination?.lon
          );
        }
      }
    }
  }, [formData?.origin, formData?.origin, formData?.destination, formData?.destination]);

  function getShipmentList() {
    setloading(true);
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    const queryParams = new URLSearchParams();
    detail_id && queryParams.append('id', detail_id);

    fetch(`${api.get_shipment}?${queryParams.toString()}`, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200) {
          const timeStart = dayjs(result.data[0].from_time, 'HH:mm:ss'); // convert string to dayjs object
          const timeEnd = dayjs(result.data[0].to_time, 'HH:mm:ss');
          const viewOrigin = {
            address: result.data[0]?.location_origin,
            city: result.data[0]?.city_origin || '',
            country: result.data[0]?.country_origin || '',
            lat: parseFloat(result.data[0]?.lat_origin),
            lon: parseFloat(result.data[0]?.lon_origin),
            state: result.data[0]?.state_origin || '',
            zone: result.data[0]?.zone_origin || '',
            zip_code: result.data[0]?.zip_code || ''
          };
          const viewDetination = {
            address: result.data[0]?.location_destination,
            city: result.data[0]?.city_destination || '',
            country: result.data[0]?.country_destination || '',
            lat: parseFloat(result.data[0]?.lat_destination),
            lon: parseFloat(result.data[0]?.lon_destination),
            state: result.data[0]?.state_destination || '',
            zone: result.data[0]?.zone_destination || '',
            zip_code: result.data[0]?.zip_code || ''
          };
          setFormData({
            origin: viewOrigin,
            destination: viewDetination,
            dho: result.data[0].dho,
            dhd: result.data[0].dhd,
            dateEarliest: result.data[0].pickup_earliest,
            dateLatest: result.data[0].pickup_lattest,
            timeStart: timeStart, // Time range for MultiInputTimeRangeField
            timeEnd: timeEnd, // Time range for MultiInputTimeRangeField
            truckType: result.data[0]?.equipment_type,
            equipmentType: result.data[0]?.equipment_id,
            length: result.data[0]?.length_ft,
            weight: result.data[0]?.weight_lbs,
            length_unit: result.data[0]?.length_unit,
            weight_unit: result.data[0]?.weight_unit,
            comment: result.data[0]?.comments,
            commodity: result.data[0]?.commodity_id,
            referenceId: result.data[0]?.reference_id,
            // contact: result.data[0]?.contact_no,
            contact: Array.isArray(result.data[0].contact)
              ? result.data[0].contact.map((d) => d.id)
              : [],
            group_id: Array.isArray(result.data[0].group)
              ? result.data[0].group.map((d) => d.id)
              : [],
            postOption: result.data[0]?.audience_type,
            private_network: result.data[0]?.network_type,
            allow_carriers: result.data[0]?.booking_rate_type ? true : false,
            request_type: result.data[0]?.booking_rate_type,
            FL_DAT_value: result.data[0]?.rate,
            // FL_Private_value: result.data[0]?.private_rate,
            allow_bids: result.data[0].allow_bid == '1' ? true : false,
            auto_bid_cancel: result.data[0].is_maximum_bid == 1 ? true : false,

            maximum_rate: result.data[0]?.maximum_bid
          });
          setloading(false);
        } else {
          setloading(false);
        }
      })
      .catch((error) => {
        console.log('error', error);
        setloading(false);
      });
  }

  const MAX_COMMENT_LENGTH = 140;

  // Handle input changes for equipment type, length, and weight
  const handleChangevalue = (e) => {
    const { name, value } = e.target;

    const maxLengthMap = {
      dho: 4,
      dhd: 4,
      length: 7,
      weight: 7,
      comment: MAX_COMMENT_LENGTH
    };

    if (maxLengthMap[name] && value.length > maxLengthMap[name]) {
      return;
    }

    // ---------- Length conversion ----------
    if (name === 'length') {
      setFormData((prev) => ({
        ...prev,
        length: value
      }));
      calculateConversion(value, formData.length_unit);
      return;
    }

    if (name === 'length_unit') {
      const newUnit = value;
      setFormData((prev) => ({
        ...prev,
        length_unit: newUnit
      }));
      calculateConversion(formData.length, newUnit);
      return;
    }

    // ---------- Weight conversion ----------
    if (name === 'weight') {
      setFormData((prev) => ({
        ...prev,
        weight: value
      }));
      calculateConversionWeight(value, formData.weight_unit);
      return;
    }

    if (name === 'weight_unit') {
      const newUnit = value;
      setFormData((prev) => ({
        ...prev,
        weight_unit: newUnit
      }));
      calculateConversionWeight(formData.weight, value);
      return;
    }

    // ---------- Default update ----------
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const calculateConversionWeight = (weight, unit) => {
    if (!weight) {
      setConvertedWeight('');
      return;
    }
    const weightValue = parseFloat(weight);
    if (isNaN(weightValue)) return;

    let convertedValue = '';
    if (unit === 'lbs') {
      convertedValue = (weightValue * 0.453592).toFixed(2) + ' kg';
    } else if (unit === 'kg') {
      convertedValue = (weightValue / 0.453592).toFixed(2) + ' lbs';
    }
    setConvertedWeight(convertedValue);
  };

  const calculateConversion = (length, unit) => {
    if (!length) {
      setConvertedLength('');
      return;
    }
    const lengthValue = parseFloat(length);
    if (isNaN(lengthValue)) return;

    let convertedValue = '';
    if (unit === 'ft') {
      convertedValue = (lengthValue * 0.3048).toFixed(2) + ' m';
    } else if (unit === 'm') {
      convertedValue = (lengthValue / 0.3048).toFixed(2) + ' ft';
    }
    setConvertedLength(convertedValue);
  };

  // Handle radio button change for truckType
  const handleChangeRadio = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      truckType: e.target.value
    }));
  };

  // Handle radio button change for Audience
  const handleChangeRadioAudience = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      private_network: e.target.value
    }));
  };

  // Handle radio button change for Request Type
  const handleChangeRadioRequestType = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      request_type: e.target.value
    }));
    // if (formData.request_type == 'All') {
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     FL_DAT_value: ''
    //   }));
    // }
    // else if (formData.request_type == 'Private') {
    //   setFormData((prevData) => ({
    //     ...prevData,
    //     FL_Private_value: ''
    //   }));
    // }
  };

  // Validate form data
  const validate = () => {
    let tempErrors = {};
    tempErrors.origin = formData?.origin ? '' : 'Origin is required.';
    tempErrors.destination = formData?.destination ? '' : 'Destination is required.';

    tempErrors.dateEarliest = formData?.dateEarliest ? '' : 'Pickup Earliest is required.';
    tempErrors.dateLatest = formData?.dateLatest ? '' : 'Pickup Latest is required.';

    // Convert the string dates to dayjs objects for comparison
    const dateEarliest = formData?.dateEarliest ? dayjs(formData?.dateEarliest) : null;
    const dateLatest = formData?.dateLatest ? dayjs(formData?.dateLatest) : null;

    // Check if both dates are provided and validate that latest date is after or the same as earliest
    if (dateEarliest && dateLatest) {
      if (dateLatest.isBefore(dateEarliest)) {
        tempErrors.dateLatest = 'Pickup Latest must be the same or after Pickup Earliest.';
      }
    }

    // Validate time range in MultiInputTimeRangeField
    if (!formData?.timeStart || !formData?.timeEnd) {
      tempErrors.timeStart = 'Both "From" and "To" times are required.';
    } else if (formData?.timeStart.isAfter(formData?.timeEnd)) {
      tempErrors.timeStart = '"From" time must be before "To" time.';
    } else {
      tempErrors.timeStart = '';
    }

    tempErrors.truckType = formData?.truckType ? '' : 'This field is required.';
    tempErrors.equipmentType = formData?.equipmentType ? '' : 'This field is required.';
    tempErrors.length = formData?.length ? '' : 'This field is required.';
    tempErrors.weight = formData?.weight ? '' : 'This field is required.';
    tempErrors.comment = formData?.comment ? '' : 'Comment is required.';
    tempErrors.commodity = formData?.commodity ? '' : 'Commodity is required.';
    tempErrors.referenceId = formData?.referenceId ? '' : 'Reference ID is required.';
    tempErrors.contact = formData?.contact ? '' : 'Contact is required.';
    tempErrors.postOption = formData?.postOption ? '' : 'Post option is required.';
    // tempErrors.private_network = formData?.private_network ? '' : 'This feild is required.';
    if (formData?.postOption == 'Private') {
      tempErrors.private_network = formData?.private_network ? '' : 'This feild is required.';
    }
    if (formData?.postOption == 'Private' && formData?.private_network == 'Group') {
      tempErrors.group_id = formData?.group_id.length !== 0 ? '' : 'Group is required.';
    }
    if (formData?.postOption == 'Private') {
      tempErrors.request_type = formData?.request_type ? '' : 'Booking rate is required.';
    }
    tempErrors.allow_carriers = formData?.allow_carriers ? '' : 'This feild is required.';

    if (formData?.request_type == 'All' || formData?.request_type == 'Private') {
      tempErrors.FL_DAT_value = formData?.FL_DAT_value ? '' : 'This field is required.';
    } // formData?.request_type == 'Private' &&
    // (tempErrors.FL_Private_value = formData?.FL_Private_value ? '' : 'This field is required.');
    if (formData?.auto_bid_cancel) {
      tempErrors.maximum_rate = formData?.maximum_rate ? '' : 'This field is required.';
    }

    setErrors(tempErrors);
    return Object.values(tempErrors).every((x) => x === '');
  };

  // close snackbarclose funtion
  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  // open profileform funtion
  const handleSecondFormOpen = () => {
    setSecondFormOpen(!secondFormOpen);
  };

  // open booking form funtion
  const handleBookingFormOpen = () => {
    setBookingFormOpen(!bookingFormOpen);
  };

  // open postform funtion
  const handlePostOpen = () => {
    setOneFormOpen(!oneFormOpen);
  };

  // Change address function
  const handleAddressChange = (newAddress) => {
    setFormData((prevData) => ({
      ...prevData,
      origin: newAddress
    }));
  };

  // Change address destination function
  const handleAddressChangeDestination = (newAddress) => {
    setFormData((prevData) => ({
      ...prevData,
      destination: newAddress || {}
    }));
  };

  const handleDateChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value ? value.toISOString() : null
    });
  };

  const handleTimeChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value // Store moment object, not the formatted string
    });
  };

  const handleCheckboxChange = (event) => {
    setFormData({
      ...formData,
      tracking: event.target.checked
    });
  };

  const handleCheckboxChangeCarriers = (event) => {
    setFormData({
      ...formData,
      allow_carriers: event.target.checked
    });
  };

  const handleCheckboxChangeBirds = (event) => {
    const isChecked = event.target.checked;

    setFormData((prevFormData) => ({
      ...prevFormData,
      allow_bids: isChecked,
      auto_bid_cancel: isChecked ? prevFormData.auto_bid_cancel : false,
      maximum_rate: isChecked ? prevFormData.maximum_rate : ''
    }));
  };

  const handleCheckboxChangeAutoBid = (event) => {
    const isChecked = event.target.checked;

    setFormData((prevFormData) => ({
      ...prevFormData,
      auto_bid_cancel: isChecked,
      maximum_rate: isChecked ? prevFormData.maximum_rate : ''
    }));
  };

  const handleCheckboxChangePostOption = (option) => {
    setFormData({
      ...formData,
      postOption: option // Set the postOption based on the checkbox clicked
    });
  };

  // Handle form submission
  const handleSubmit = (status, type) => {
    if (validate()) {
      // Additional validation for 'All' request type
      if (formData?.request_type === 'All' && formData.auto_bid_cancel) {
        if (formData.maximum_rate === '') {
          setErrors((old) => ({
            ...old,
            maximum_rate: 'This field is required.'
          }));
          return; // Exit early if there's an error
        } else if (formData.maximum_rate < formData?.FL_DAT_value) {
          setErrors((old) => ({
            ...old,
            maximum_rate: "The 'Maximum Rate' must be greater than 'Flat Rate'."
          }));
          return; // Exit early if there's an error
        } else {
          // Clear the error if validation passes
          setErrors((old) => ({
            ...old,
            maximum_rate: ''
          }));
        }
      }
      // else if (formData?.request_type === 'Private' && formData.auto_bid_cancel) {
      //   if (formData.maximum_rate === '') {
      //     setErrors((old) => ({
      //       ...old,
      //       maximum_rate: 'This field is required.'
      //     }));
      //     return; // Exit early if there's an error
      //   }
      //   //  else if (formData.maximum_rate < formData?.FL_Private_value) {
      //   //   setErrors((old) => ({
      //   //     ...old,
      //   //     maximum_rate: "The 'Maximum Rate' must be greater than 'Flat Rate'."
      //   //   }));
      //   //   return; // Exit early if there's an error
      //    else {
      //     // Clear the error if validation passes
      //     setErrors((old) => ({
      //       ...old,
      //       maximum_rate: ''
      //     }));
      //   }
      // }

      // Call the AddShipmentFunction only if all validations pass
      AddShipmentFunction(status, type);
    }
  };

  //add shipment function
  function AddShipmentFunction(status, type) {
    setIsSaveLoading(type);

    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const convertTo24HourFormatFromObject = (dateObject) => {
      const date = new Date(dateObject.$d); // $d property se Date object nikal lo
      const hours = date.getHours().toString().padStart(2, '0'); // Local hours
      const minutes = date.getMinutes().toString().padStart(2, '0'); // Local minutes
      return `${hours}:${minutes}`;
    };

    const formdatas = new FormData();
    detail_id && formdatas.append('id', detail_id); // Required
    formdatas.append('location_origin', formData?.origin?.address); // Required
    formData?.origin?.country && formdatas.append('country_origin', formData?.origin?.country); // Optional
    formData?.origin?.city && formdatas.append('city_origin', formData?.origin?.city); // Optional
    formData?.origin?.state && formdatas.append('state_origin', formData?.origin?.state); // Optional
    formdatas.append('lat_origin', formData?.origin?.lat); // Required
    formdatas.append('lon_origin', formData?.origin?.lon); // Required
    formData?.origin?.zone && formdatas.append('zone_origin', formData?.origin?.zone); // Required

    formdatas.append('location_destination', formData?.destination?.address); // Required
    formData?.destination?.country &&
      formdatas.append('country_destination', formData?.destination?.country); // Optional
    formData?.destination?.city &&
      formdatas.append('city_destination', formData?.destination?.city); // Optional
    formData?.destination?.state &&
      formdatas.append('state_destination', formData?.destination?.state); // Optional
    formdatas.append('lat_destination', formData?.destination?.lat); // Required
    formdatas.append('lon_destination', formData?.destination?.lon); // Required
    formData?.destination?.zone &&
      formdatas.append('zone_destination', formData?.destination?.zone); // Required

    formData?.dho && formdatas.append('dho', formData?.dho); // Required
    formData?.dhd && formdatas.append('dhd', formData?.dhd); // Required

    formdatas.append('total_mil', formData?.distance); // Required

    formdatas.append('pickup_earliest', moment(formData?.dateEarliest).format('YYYY-MM-DD')); // Required
    formdatas.append('pickup_lattest', moment(formData?.dateLatest).format('YYYY-MM-DD')); // Required

    formdatas.append('from_time', convertTo24HourFormatFromObject(formData?.timeStart)); // Required
    formdatas.append('to_time', convertTo24HourFormatFromObject(formData?.timeEnd)); // Required

    formdatas.append('equipment_type', formData?.truckType); // Required (Full | Partial)
    formdatas.append('equipment_id', formData?.equipmentType); // Required

    formdatas.append('length_ft', formData?.length); // Required
    formdatas.append('weight_lbs', formData?.weight); // Required

    formdatas.append('length_unit', formData?.length_unit); // Required
    formdatas.append('weight_unit', formData?.weight_unit); // Required

    formdatas.append('comments', formData?.comment); // Optional
    formdatas.append('reference_id', formData?.referenceId); // Optional
    formdatas.append('commodity_id', formData?.commodity); // Optional
    formdatas.append('contact_id', formData?.contact); // Required

    formdatas.append('audience_type', formData?.postOption); // Required (Private | All)
    formdatas.append('network_type', formData?.private_network); // If (audience_type = "Private") Then this is Required. (Private | Group)

    formdatas.append('booking_rate_type', formData?.request_type); // Required (Private | All)
    formData?.request_type == 'All' && formdatas.append('rate', formData?.FL_DAT_value); // If (booking_rate_type = "All") Then this is Required.
    formData?.request_type == 'Private' && formdatas.append('private_rate', formData?.FL_DAT_value); // If (booking_rate_type = "Private") Then this is Required.
    formdatas.append('allow_bid', formData?.allow_bids ? 1 : 0); // Optional
    formdatas.append('is_maximum_bid', formData?.auto_bid_cancel ? 1 : 0); // Optional
    formData?.auto_bid_cancel && formdatas.append('maximum_bid', formData?.maximum_rate); // Optional
    status && formdatas.append('status', status); // Optional

    if (formData?.postOption == 'Private' && formData?.private_network == 'Group') {
      formdatas.append('group_id', formData?.group_id);
    }

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdatas,
      redirect: 'follow'
    };

    fetch(api.save_shipment, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          setTimeout(() => {
            navigate(-1);
            setIsSaveLoading(null);
          }, 2000);
        } else {
          setIsSaveLoading(null);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setIsSaveLoading(null);
        setSnackbarMessage('An error occurred.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      });
  }

  // const handleGetKilometers = (originLat, originLng, destinationLat, destinationLng) => {
  //   const origin = { latitude: originLat, longitude: originLng };
  //   const destination = { latitude: destinationLat, longitude: destinationLng };

  //   const distanceInMeters = getDistance(origin, destination);
  //   const distanceInKilometers = distanceInMeters / 1000; // Convert meters to kilometers

  //   setFormData({
  //     ...formData,
  //     distance: distanceInKilometers.toFixed(2) // Update the distance in kilometers
  //   });
  // };

  const handleGetKilometers = (originLat, originLng, destinationLat, destinationLng) => {
    // 🔐 Guard clause
    if (
      originLat == null ||
      originLng == null ||
      destinationLat == null ||
      destinationLng == null
    ) {
      console.warn('Invalid coordinates', {
        originLat,
        originLng,
        destinationLat,
        destinationLng
      });
      return;
    }

    const origin = {
      latitude: Number(originLat),
      longitude: Number(originLng)
    };

    const destination = {
      latitude: Number(destinationLat),
      longitude: Number(destinationLng)
    };

    const distanceInMeters = getDistance(origin, destination);
    const distanceInKilometers = distanceInMeters / 1000;

    setFormData((prev) => ({
      ...prev,
      distance: distanceInKilometers.toFixed(2)
    }));
  };

  return (
    <Page
      title={`${
        (viewOnly && 'View Details') ||
        (!viewOnly && detail_id && 'Edit Shipment') ||
        'Add New Shipment'
      } | ${process.env.REACT_APP_PROJECTNAME}`}
    >
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
          <IconButton
            style={{
              marginRight: 12,
              height: 40,
              width: 70,
              borderRadius: 5,
              backgroundColor: 'rgba(209,209,209,0.3)'
            }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#010f58' }} />
          </IconButton>
          <Typography variant="h4" style={{ flex: 1, color: '#010f58' }}>
            {(viewOnly && 'View Details') ||
              (!viewOnly && detail_id && 'Edit Shipment') ||
              'Add New Shipment'}
          </Typography>
        </Stack>

        {/* loader */}
        {loading ? (
          <Box
            py={5}
            style={{
              display: 'flex',
              justifyContent: 'center',
              flex: 1
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Scrollbar style={{ paddingLeft: 10, paddingRight: 10, paddingBottom: 30 }}>
            <ShipmentDetailsForm
              disabled={viewOnly}
              detail_id={detail_id}
              postOpen={oneFormOpen}
              formData={formData}
              errors={errors}
              handleChangevalue={handleChangevalue} // Handling other input changes
              handlePostOpen={handlePostOpen} // Handling radio change
              handleTimeChange={handleTimeChange}
              handleDateChange={handleDateChange}
              onResultAddress={(val) => {
                handleAddressChange(val);
              }}
              onResultAddressDestination={(val) => {
                handleAddressChangeDestination(val);
              }}
              MAX_COMMENT_LENGTH={MAX_COMMENT_LENGTH}
              handleChangeRadio={handleChangeRadio}
              handleCheckboxChange={handleCheckboxChange}
              setFormData={setFormData}
              convertedLength={convertedLength}
              convertedWeight={convertedWeight}
            />

            <AudienceForm
              disabled={viewOnly}
              secondFormOpen={secondFormOpen}
              formData={formData}
              errors={errors}
              handleChangevalue={handleChangevalue} // Handling other input changes
              handleSecondFormOpen={handleSecondFormOpen} // Handling radio change
              handleChangeRadio={handleChangeRadioAudience}
              handleCheckboxChangePostOption={handleCheckboxChangePostOption}
            />

            <BookingRate
              disabled={viewOnly}
              BookingFormOpen={bookingFormOpen}
              formData={formData}
              errors={errors}
              handleCheckboxChangeCarriers={handleCheckboxChangeCarriers}
              handleCheckboxChangeBirds={handleCheckboxChangeBirds}
              handleChangevalue={handleChangevalue} // Handling other input changes
              handleBookingFormOpen={handleBookingFormOpen} // Handling radio change
              handleChangeRadio={handleChangeRadioAudience}
              handleChangeRadioRequestType={handleChangeRadioRequestType}
              handleCheckboxChangeAutoBid={handleCheckboxChangeAutoBid}
            />
          </Scrollbar>
        )}

        {!viewOnly && !loading && detail_id && (
          <Stack direction="row" alignItems="center" justifyContent="flex-end" px={1}>
            <LoadingButton
              variant="contained"
              loading={isSaveLoading == 'save'}
              onClick={() => handleSubmit(data.status, 'save')}
              disabled={viewOnly}
              style={{ backgroundColor: '#010f58' }}
            >
              Post Shipment
            </LoadingButton>
            {data.status.toLowerCase() == 'pending' && (
              <LoadingButton
                variant="contained"
                loading={isSaveLoading == 'exit'}
                onClick={() => handleSubmit(data.status, 'exit')}
                disabled={viewOnly}
                style={{ backgroundColor: '#010f58', marginLeft: 20 }}
              >
                Save and exit
              </LoadingButton>
            )}
          </Stack>
        )}
        {!viewOnly && !loading && !detail_id && (
          <Stack direction="row" alignItems="center" justifyContent="flex-end" px={1}>
            <LoadingButton
              variant="contained"
              loading={isSaveLoading == 'save'}
              onClick={() => handleSubmit('1', 'save')}
              disabled={viewOnly}
              style={{ backgroundColor: '#010f58' }}
            >
              Post Shipment
            </LoadingButton>
            <LoadingButton
              variant="contained"
              loading={isSaveLoading == 'exit'}
              onClick={() => handleSubmit('11', 'exit')}
              disabled={viewOnly}
              style={{ backgroundColor: '#010f58', marginLeft: 20 }}
            >
              Save and exit
            </LoadingButton>
          </Stack>
        )}
        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
